import React from 'react';
import { ContentBox } from '../ContentBox/ContentBox';
import { formatterCurrency } from '@common/utils/formatters/formatter';

interface IProps {
  loanSelected: any;
}

export const BoxFees: React.FC<IProps> = ({ loanSelected }: IProps) => {
  let originationFeePercent = loanSelected?.salesforceData?.fees?.originationFeePercent
  let originationFee = loanSelected?.salesforceData?.fees?.originationFee

  if (!originationFeePercent) {
    originationFeePercent = 2
    originationFee = ((loanSelected?.loanData?.selectedOption?.totalLoanAmount || 0) * (originationFeePercent/100))
  }

  const data = {
    originationFee: `${formatterCurrency(originationFee)} (${(originationFeePercent).toFixed(2)}%)`,
    processingFee: formatterCurrency(loanSelected?.salesforceData?.fees?.processingFee || 0),
    proRatedInterest: formatterCurrency(loanSelected?.salesforceData?.fees?.proRatedInterest || 0),
    thirdPartyCosts: "Contact closing agent",
    prepay: loanSelected?.salesforceData?.fees?.prepay || "3 Months",
    assignmentFee: formatterCurrency(loanSelected?.salesforceData?.fees?.assignmentFee || 0),
    floodCertificationFee: formatterCurrency(loanSelected?.salesforceData?.fees?.floodCertificationFee || 0),
    creditAndBackgroundCheckFee: formatterCurrency(loanSelected?.salesforceData?.fees?.creditAndBackgroundCheckFee || 0),
    miscFees: formatterCurrency(loanSelected?.salesforceData?.fees?.miscFees || 0),
    overnightDeliveryFee: formatterCurrency(loanSelected?.salesforceData?.fees?.overnightDeliveryFee || 0),
    lenderLegalFee: formatterCurrency(loanSelected?.salesforceData?.fees?.lenderLegalFee || 0),
    insurancePremiumToBeCollected: formatterCurrency(loanSelected?.salesforceData?.fees?.insurancePremiumToBeCollected || 0),
    totalLoanFees: formatterCurrency(loanSelected?.salesforceData?.fees?.totalLoanFees || 0),
  }

  return (
    <ContentBox
      label={'Fees'}
      content={[
        { field: 'Origination fee', value: data.originationFee },
        { field: 'Processing fee', value: data.processingFee },
        { field: 'Pro-rated interest', value: data.proRatedInterest },
        { field: 'Third-party costs', value: data.thirdPartyCosts },
        { field: 'Prepay', value: data.prepay },
        { field: 'Assignment fee', value: data.assignmentFee },
        { field: 'Flood certification fee', value: data.floodCertificationFee },
        { field: 'Credit and background check fee', value: data.creditAndBackgroundCheckFee },
        { field: 'Misc fees', value: data.miscFees },
        { field: 'Overnight delivery fee', value: data.overnightDeliveryFee },
        { field: 'Lender legal fee', value: data.lenderLegalFee },
        { field: 'Insurance premium to be collected', value: data.insurancePremiumToBeCollected },
        { field: 'Total loan fees', value: data.totalLoanFees },
      ]}
    />
  );
}